export const SMS_REQUEST_SENT = 'SMS_REQUEST_SENT';
export const SMS_RESPONSE_RECEIEVED = 'SMS_RESPONSE_RECEIEVED';
export const SMS_SEND_FAILED = 'SMS_SEND_FAILED';
